export default {
  title: {
    edit: 'Update the spot',
    create: 'Create a new spot',
  },
  form: {
    name: 'Label',
    submit: 'Save',
  },
  delete: {
    title: 'Remove this spot',
    button: 'Remove this spot',
    confirm: {
      title: 'Please confirm the removale of the "{{name}}" spot',
      warning: 'Warning',
      helper: 'The spot will be removed from the group, but will not be deleted.',
      submit: 'Remove this spot',
    },
  },
  tooltip: {
    lastspot: 'deletion not allowed: active subscription',
  },
}
